import { create } from 'zustand';

/**
 * 조직도 내부 팝업 열림 상태 — allMenuStore 동형(zustand).
 *
 * 좌측 레일의 "조직도" 는 원래 /organization 페이지로 이동했다. 사용자 요청(2026-08-17)으로
 * **페이지 이동 대신 앱 위에 뜨는 내부 팝업**으로 바꾸되, 페이지·라우트는 그대로 둔다
 * (회귀 0 — 주소로 직접 들어오면 기존 화면이 그대로 뜬다).
 *
 * persist 하지 않는다 — 오버레이라 새로고침 후 열려 있으면 방해된다(allMenuStore 와 같은 판단).
 */
/**
 * 연 버튼의 화면 위치 — 팝업을 **그 옆에** 띄우기 위해 함께 싣는다.
 * DOMRect 를 그대로 두면 참조가 살아 있어 나중에 값이 바뀔 수 있으므로 숫자만 복사한다.
 */
export interface OrgDirectoryAnchor {
  left: number;
  top: number;
  right: number;
  bottom: number;
}

export function anchorOf(el: Element): OrgDirectoryAnchor {
  const r = el.getBoundingClientRect();
  return { left: r.left, top: r.top, right: r.right, bottom: r.bottom };
}

interface OrgDirectoryState {
  open: boolean;
  /** 없으면 좌측 레일 기본 위치로 띄운다. */
  anchor: OrgDirectoryAnchor | null;
  openModal: (anchor?: OrgDirectoryAnchor | null) => void;
  close: () => void;
  /** 같은 버튼을 다시 누르면 닫힌다(레일 토글). */
  toggle: (anchor?: OrgDirectoryAnchor | null) => void;
}

export const useOrgDirectoryStore = create<OrgDirectoryState>((set) => ({
  open: false,
  anchor: null,
  openModal: (anchor = null) => set({ open: true, anchor }),
  close: () => set({ open: false }),
  toggle: (anchor = null) => set((s) => (s.open ? { open: false } : { open: true, anchor })),
}));
